// src/store/modules/positions/actions.js

import { get, post } from '@/services/api';
export default {
  async getPositions(context, { offset, count }) {
    console.log(`📦 Calling getPosition  | offset=${offset}, count=${count}`);
    try {
      const response = await get(`/trade/get-all-positions?offset=${offset}&count=${count}`);
      console.log(`📦 Get Positions API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get Positions API error:', error);
      throw error;
    }
  },

  async refreshLtpForPositions() {
    console.log(`📦 Calling refreshLtpForPositions`);
    try {
      await post(`/trade/refresh-ltp-for-positions`);
    } catch (error) {
      console.error('❌ Refresh Positions API error:', error);
      throw error;
    }
  },
  async refreshPositions() {
    console.log(`📦 Calling refreshPositions`);
    try {
      await post(`/trade/fetch-porfolio-details`);
    } catch (error) {
      console.error('❌ Refresh Positions API error:', error);
      throw error;
    }
  },
  async updatePosition(context, payload) {
    console.log('📦 update Position in action', payload);
    try {
      const response = await post(`/trade/update-position`, payload);
      console.log(`📦 Update Position API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Update Position API error:', error);
      throw error;
    }
  },
    async updateExitPrice(context, payload) {
    console.log('📦 update Exit Price in action', payload);
    try {
      const response = await post(`/trade/update-exit-price`, payload);
      console.log(`📦 Update Exit Price API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Update Exit Price API error:', error);
      throw error;
    }
  },
  async fetchExitPriceFromOrder(context, payload) { 
    console.log('📦 fetch Exit Price from order in action', payload); 
    try {
      const response = await get(`/trade/fetch-exit-price-from-order`, {
        params: {
          expiry_date: payload.expiry_date,
          strike_price: payload.strike_price,
          right: payload.right,
          quantity: payload.quantity,
          action_type: payload.action_type
        }
      });
      console.log(`📦 fetch Exit Price from order API response:`, response.data);
      return response.data;
    } catch (error) {
      console.error('❌ fetch Exit Price from order API error:', error);
      throw error;
    }
  }
  

}
